import { Switch as ChakraSwitch, SwitchProps as ChakraSwitchProps, FormErrorMessageProps } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';
import { FormErrorMessage } from 'components/UI/forms';

export type SwitchProps = ChakraSwitchProps & {
  error?: string;
  errorProps?: FormErrorMessageProps;
};

const SwitchStyles: ComponentStyleConfig = {
  baseStyle: {
    track: {
      _focus: {
        boxShadow: 'none',
      },
    },
  },
  sizes: {
    md: {
      track: {
        w: 50,
        h: 19,
        bg: 'gray.300',
        _checked: {
          bg: 'primaryThemeColour.400',
        },
      },
      thumb: {
        w: 19,
        h: 19,
        _checked: {
          transform: 'translateX(32px)',
        },
      },
    },
  },
};

const Switch = ({ name, errorProps = {}, error, isChecked, size = 'md', ...props }: SwitchProps) => (
  <>
    <ChakraSwitch colorScheme="primaryThemeColour" isChecked={isChecked} size={size} {...props} name={name} id={name} />
    <FormErrorMessage {...errorProps}>{error}</FormErrorMessage>
  </>
);

export { Switch, SwitchStyles };
